import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withApollo, Query } from 'react-apollo'
import omit from 'lodash/omit'

import {
  MESSAGE_TYPES,
  MESSAGE_LABEL_OPTIONS,
  MESSAGE_DESTINATION_OPTIONS,
} from 'config/constants'
import {
  MESSAGES_QUERY,
  MESSAGE_QUERY,
  TOPICS_QUERY,
  CONTENTS_QUERY,
} from 'graphql/queries'
import { CREATE_MESSAGE, UPDATE_MESSAGE } from 'graphql/mutations'

import { Container, Header, Button, Form } from 'semantic-ui-react'
import Select from 'react-select'

class NewMessage extends Component {
  state = {
    title: '',
    text: '',
    topic: '',
    userIds: '',
    type: 'reminder',
    category: '',
    name: '',
    content: '',
    imgUrl: '',
    webUrl: '',
    ctaText: '',
    cta: '',
    param: '',
    campaignId: '',
    articleId: '',
    contentQuery: '',
  }

  componentDidMount() {
    this.initializeEditState()
  }

  initializeEditState = () => {
    const {
      location,
      match: { params },
      client,
    } = this.props
    if (location.pathname.includes('edit') && params.messageId) {
      client
        .query({ query: MESSAGE_QUERY, variables: { id: params.messageId } })
        .then(({ data }) => {
          let initialState = omit(data.message, '__typename')
          initialState = {
            ...initialState,
            ...initialState.data,
            articleId: initialState.data.id,
          }
          delete initialState.data

          if (initialState.userIds) {
            initialState.userIds = initialState.userIds.join(',')
          }

          Object.keys(initialState).forEach(
            key => initialState[key] == null && delete initialState[key],
          )
          this.setState({ ...this.state, ...initialState })
        })
    }
  }

  convertStateToVariables = () => {
    const {
      title,
      text,
      topic,
      userIds,
      type,
      category,
      name,
      content,
      webUrl,
      ctaText,
      cta,
      campaignId,
      articleId,
    } = this.state

    let variables = { input: {} }
    switch (type) {
      case 'content':
        variables.input = {
          title,
          text,
          topic,
          data: {
            id: articleId,
            type,
            category,
            name,
            content,
            campaignId,
          },
        }
        break
      case 'external':
        variables.input = {
          title,
          text,
          topic,
          data: {
            webUrl,
            type,
            category,
            name,
            campaignId,
          },
        }
        break
      case 'info':
        variables.input = {
          title,
          text,
          topic,
          data: {
            type,
            category,
            name,
            content,
            campaignId,
          },
        }
        break
      case 'reminder':
        variables.input = {
          title,
          text,
          topic,
          data: {
            type,
            category,
            name,
            content,
            ctaText,
            cta,
            campaignId,
          },
        }
        break
      default:
        break
    }

    if (topic === 'userIds') {
      variables.input.userIds = userIds.includes(',')
        ? userIds.split(',')
        : [userIds]
    }

    return variables
  }

  handleSave = () => {
    const {
      match: { params },
      location,
      client,
    } = this.props
    const isEditing = location.pathname.includes('edit')

    const variables = this.convertStateToVariables()

    if (isEditing) {
      return client
        .mutate({
          mutation: UPDATE_MESSAGE,
          refetchQueries: [{ query: MESSAGES_QUERY }],
          variables: { id: params.messageId, input: variables.input },
        })
        .then(() => {
          this.props.history.push('/messages')
        })
    }
    return client
      .mutate({
        mutation: CREATE_MESSAGE,
        refetchQueries: [{ query: MESSAGES_QUERY }],
        variables,
      })
      .then(() => {
        this.props.history.push('/messages')
      })
  }

  renderCTAMessage() {
    const {
      type,
      category,
      cta,
      ctaText,
      name,
      content,
      campaignId,
    } = this.state
    const hasCTA = type === 'reminder'
    return (
      <React.Fragment>
        <Header
          as="h2"
          content={hasCTA ? 'Message with CTA' : 'Message without CTA'}
        />
        <div>
          <label htmlFor="category">Category</label>
          <Select
            id="category"
            value={MESSAGE_LABEL_OPTIONS.find(o => o.value === category)}
            options={MESSAGE_LABEL_OPTIONS}
            onChange={option => this.setState({ category: option.value })}
          />
        </div>

        {hasCTA && (
          <React.Fragment>
            <label htmlFor="cta">CTA Destination</label>
            <Select
              id="cta"
              value={MESSAGE_DESTINATION_OPTIONS.find(o => o.value === cta)}
              options={MESSAGE_DESTINATION_OPTIONS.filter(
                option => !option.onlyWelcome,
              )}
              onChange={option => this.setState({ cta: option.value })}
            />
            <Form.Input
              label="CTA Text"
              id="ctaText"
              value={ctaText}
              onChange={event => this.setState({ ctaText: event.target.value })}
            />
          </React.Fragment>
        )}
        <Form.Input
          label="Message Title"
          id="name"
          value={name}
          onChange={event => this.setState({ name: event.target.value })}
        />

        <Form.Input
          label="Message Content"
          id="content"
          value={content}
          onChange={event => this.setState({ content: event.target.value })}
        />

        <Form.Input
          label="Campaign ID"
          id="campaignId"
          value={campaignId}
          onChange={event => this.setState({ campaignId: event.target.value })}
        />
      </React.Fragment>
    )
  }

  renderExternalMessage() {
    return (
      <React.Fragment>
        <Header as="h2" content="External Article Message" />
        <Form.Input
          label="External Article Title"
          id="name"
          value={this.state.name}
          onChange={event => this.setState({ name: event.target.value })}
          maxLength={100}
        />
        <Form.Input label="External Article URL" id="webUrl" type="url" />
      </React.Fragment>
    )
  }

  renderArticleMessage() {
    return (
      <React.Fragment>
        <Header as="h2" content="PainScale Article Message" />
        <label htmlFor="articleId">Article</label>
        <Query
          query={CONTENTS_QUERY}
          variables={{ limit: 10, q: this.state.contentQuery }}
        >
          {({ data, loading }) => {
            const options = loading
              ? []
              : data.contents.map(content => ({
                  id: content.id,
                  title: content.title,
                }))
            return (
              <Select
                options={options}
                isLoading={loading}
                name="articleId"
                placeholder="Search for an article"
                getOptionLabel={option => option.title}
                getOptionValue={option => option.id}
                value={options.find(o => o.id === this.state.articleId)}
                onChange={option =>
                  this.setState({
                    name: option.title,
                    articleId: option.id,
                  })
                }
                onInputChange={contentQuery => this.setState({ contentQuery })}
              />
            )
          }}
        </Query>
        <Form.Input
          label="Article Lead-in Copy"
          name="content"
          value={this.state.content}
          onChange={event => this.setState({ content: event.target.value })}
          maxLength={350}
        />
      </React.Fragment>
    )
  }

  renderType() {
    switch (this.state.type) {
      case 'content':
        return this.renderArticleMessage()
      case 'external':
        return this.renderExternalMessage()
      case 'info':
      case 'reminder':
      default:
        return this.renderCTAMessage()
    }
  }

  render() {
    const { topic } = this.state
    const showUserIdTextArea = topic === 'userIds'

    return (
      <Container style={{ marginBottom: 32 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Header as="h1" content="New Message" />

          <div>
            <Button primary onClick={this.handleSave}>
              {!!this.props.match.params.messageId ? 'Update' : 'Create'}
            </Button>
            <Link to="/messages">
              <Button primary color="red">
                Cancel
              </Button>
            </Link>
          </div>
        </div>

        <Form>
          <label>Message Type</label>
          <Select
            value={MESSAGE_TYPES.find(o => o.value === this.state.type)}
            options={MESSAGE_TYPES}
            onChange={option => this.setState({ type: option.value })}
          />
          <label htmlFor="topic">Send to Audience/Topic</label>
          <Query query={TOPICS_QUERY}>
            {({ data, loading }) => {
              const topics = loading ? [] : data.topics
              return (
                <Select
                  isLoading={loading}
                  value={topics.find(o => o.id === this.state.topic)}
                  options={[
                    {
                      id: 'userIds',
                      name: 'Specific Users',
                    },
                  ].concat(topics)}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  onChange={option =>
                    this.setState({
                      topic: option.id,
                    })
                  }
                />
              )
            }}
          </Query>

          {showUserIdTextArea && (
            <Form.TextArea
              value={this.state.userIds}
              onChange={event => this.setState({ userIds: event.target.value })}
              label="User IDs* (i.e: user1,user2,user3)"
              name="userIds"
              maxLength={350}
            />
          )}

          {this.renderType()}

          <Header as="h2" content="Push Notification" />
          <p>Leave blank fields for no push</p>

          <Form.Input
            label="Push Title"
            name="title"
            value={this.state.title}
            onChange={event => this.setState({ title: event.target.value })}
            maxLength={30}
          />
          <Form.Input
            label="Push Text Body"
            name="text"
            value={this.state.text}
            onChange={event => this.setState({ text: event.target.value })}
            maxLength={116}
          />
        </Form>
      </Container>
    )
  }
}

export default withApollo(NewMessage)
